import _import_ from "@assets/js/pub_import.js";
const BASE_URL = "generic";
// const BASE_URL_PRO = "proGeneric";
export default [
  {
    path: "/generic",
    component: _import_(BASE_URL + "/generic.vue")
  },
  {
    path: "/mapTo",
    component: _import_(BASE_URL + "/mapTo.vue")
  },
  // {
  //     path: "/proj_ge",
  //     component: _import_(BASE_URL_PRO + "/proGeneric.vue")
  // },
];
